import type { CookieAttributes } from "../cookie.types";

export class CookieConfigDTO {
  name: string;
  value: string | object;
  attributes?: CookieAttributes;

  constructor(params: Partial<CookieConfigDTO>) {
    this.name = params.name ?? "";
    this.value = params.value ?? "";
    this.attributes = params.attributes || {};
  }
}
